import { memo } from 'react';
import type { Dayjs } from 'dayjs';
import type { WorkOrderListItem } from '../../../../types/InfrastructureManagerTypes';
import { CALENDAR_DAY_KEY_FORMAT, CALENDAR_WEEKDAY_LABELS } from '../constants';
import { getCellSelectedId } from '../workOrderList.utils';
import CalendarDayCell from './CalendarDayCell';
import styles from './WorkOrderCalendar.module.scss';

interface WeekViewProps {
  weekStart: Dayjs;
  todayKey: string;
  dayIndex: Map<string, WorkOrderListItem[]>;
  selectedId: number | null;
  onSelect: (id: number) => void;
  onExpand: (id: number) => void;
}

const WeekView = ({ weekStart, todayKey, dayIndex, selectedId, onSelect, onExpand }: WeekViewProps) => (
  <div className={styles.weekView}>
    {CALENDAR_WEEKDAY_LABELS.map((label) => (
      <span key={label} className={styles.weekViewLabel}>
        {label}
      </span>
    ))}
    {CALENDAR_WEEKDAY_LABELS.map((label, offset) => {
      const date = weekStart.add(offset, 'day');
      const key = date.format(CALENDAR_DAY_KEY_FORMAT);
      const orders = dayIndex.get(key);
      return (
        <CalendarDayCell
          key={label}
          day={date.date()}
          orders={orders}
          selectedId={getCellSelectedId(orders, selectedId)}
          isToday={key === todayKey}
          onSelect={onSelect}
          onExpand={onExpand}
        />
      );
    })}
  </div>
);

export default memo(WeekView);
